import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { Constants } from "../../../shared/utilities/Constants";
import { FormatIsoAddressFieldsService } from "../../../shared/services/format-isoAddressFields.service";
import { OptionDropdownSelect } from "../../models/OptionDropdownSelect";
import { CountryDescriptionFromCode } from "../../../shared/utilities/CountryDescriptionFromCode";

@Component({
  standalone: false,
    selector: 'mm-wire-iso-four-step-intermediary',
    templateUrl: './wire-iso-four-step-intermediary.component.html',
    styleUrls: ['./wire-iso-four-step-intermediary.component.scss'],
  })
  export class WireIsoFourStepComponent implements OnInit, OnDestroy {

    @Input() parentForm: UntypedFormGroup;
    @Input() useSloa: boolean;
    @Input() countryList: OptionDropdownSelect[];
    thirdIntermediaryHeader: string =  Constants.thirdIntermediaryNameAddressSubHeader;
    thirdIntermediaryUseSloaAddress: string;
    thirdIntermediaryAccountNumber: string;
    thirdIntermediaryUseSloaAccountNumberHeader: string = "Account number";
    thirdIntermediaryBIC: string;
    thirdIntermediaryClearingSysId: string;

    
    destroy$: Subject<boolean> = new Subject<boolean>();
    
    constructor(private formatIsoAddressFieldsService: FormatIsoAddressFieldsService) {}
    

    ngOnInit(): void {
      this.thirdIntermediaryAccountNumber = (this.parentForm?.value?.thirdIntermediaryAccountNumber != null && this.parentForm?.value?.thirdIntermediaryAccountNumber != undefined) ? this.parentForm?.value?.thirdIntermediaryAccountNumber : 
                                    ((this.parentForm?.value?.thirdIntermediaryIBAN != null && this.parentForm?.value?.thirdIntermediaryIBAN != undefined) ? this.parentForm?.value?.thirdIntermediaryIBAN : null);
      this.thirdIntermediaryBIC = this.parentForm?.value?.thirdIntermediaryBIC;
      this.thirdIntermediaryClearingSysId = this.parentForm?.value?.thirdIntermediaryClearingSysId;
      this.thirdIntermediaryUseSloaAccountNumberHeader = (this.parentForm?.value?.thirdIntermediaryIBAN != null && this.parentForm?.value?.thirdIntermediaryIBAN != undefined) ? 'International account number (IBAN)' : this.thirdIntermediaryUseSloaAccountNumberHeader; 
      const thirdIntermediaryCountry = this.parentForm?.value?.thirdIntermediaryCountry?.length == 2 ? CountryDescriptionFromCode(this.parentForm?.value?.thirdIntermediaryCountry, this.countryList): this.parentForm?.value?.thirdIntermediaryCountry;

      this.thirdIntermediaryUseSloaAddress = this.getIntermediarySloaReadOnlyAddress(this.parentForm?.value?.thirdIntermediaryName, this.parentForm?.value?.thirdIntermediaryStreetNumber, this.parentForm?.value?.thirdIntermediaryStreetName, this.parentForm?.value?.thirdIntermediaryApartmentSuiteEtc, this.parentForm?.value?.thirdIntermediaryDepartment, this.parentForm?.value?.thirdIntermediaryBuildingName, this.parentForm?.value?.thirdIntermediaryFloor, this.parentForm?.value?.thirdIntermediaryTownLocationName, this.parentForm?.value?.thirdIntermediaryCity, this.parentForm?.value?.thirdIntermediaryDistrict, this.parentForm?.value?.thirdIntermediaryState, this.parentForm?.value?.thirdIntermediaryZip, thirdIntermediaryCountry);
    }

  getIntermediarySloaReadOnlyAddress(name?: string, streetNumber?: string, streetName?: string, apartmentSuiteEtc?: string, department?: string, buildingName?: string, floor?: string, townLocationName?: string, city?: string, district?: string, state?: string, zipCode?: string, country?: string) {
    return this.formatIsoAddressFieldsService.getFieldsValue(name) +
      this.formatIsoAddressFieldsService.getNextLine(name) +
      this.formatIsoAddressFieldsService.getFieldsValue(streetNumber ? streetNumber + " " + streetName : streetName) +
      this.formatIsoAddressFieldsService.getNextLine(streetNumber ? streetNumber + " " + streetName : streetName) +
      this.formatIsoAddressFieldsService.getFieldsValue(apartmentSuiteEtc, department, buildingName, floor) +
      this.formatIsoAddressFieldsService.getFieldsValue(department, buildingName, floor) +
      this.formatIsoAddressFieldsService.getFieldsValue(buildingName, floor) +
      this.formatIsoAddressFieldsService.getFieldsValue(floor) +
      this.formatIsoAddressFieldsService.getNextLine(apartmentSuiteEtc, department, buildingName, floor) +
      this.formatIsoAddressFieldsService.getFieldsValue(townLocationName, city, district, state, zipCode) +
      this.formatIsoAddressFieldsService.getFieldsValue(city, district, state, zipCode) +
      this.formatIsoAddressFieldsService.getFieldsValue(district, state, zipCode) +
      this.formatIsoAddressFieldsService.getFieldsValue(state, zipCode) +
      this.formatIsoAddressFieldsService.getFieldsValue(zipCode) +
      this.formatIsoAddressFieldsService.getNextLine(townLocationName, city, district, state, zipCode) +
      this.formatIsoAddressFieldsService.getFieldsValue(country) +
      this.formatIsoAddressFieldsService.getNextLine(country) 
  }

    ngOnDestroy(): void {
      this.destroy$.next(true);
      this.destroy$.unsubscribe();
    }
  }
